import { useTranslations } from "@jugl-web/utils";
import React from "react";

export const EmptyInfoElement: React.FC = () => {
  const { t } = useTranslations();

  return (
    <span className="mt-1 font-secondary text-[13px] leading-[140%] text-grey-800">
      {t({
        id: "chats-page.no-info-added",
        defaultMessage: "No Info added",
      })}
    </span>
  );
};
